// Cart Update Fix V2 - Fixes BOTH drawer AND cart page
// Handles remove buttons and quantity changes

(function() {
  'use strict';
  
  // Handle remove buttons in BOTH drawer AND cart page
  document.addEventListener('click', function(e) {
    const removeButton = e.target.closest('cart-remove-button button, cart-remove-button a');
    
    if (!removeButton) return;
    
    const cartRemoveButton = removeButton.closest('cart-remove-button');
    if (!cartRemoveButton) return;
    
    // Check if we're in the drawer or cart page
    const isInDrawer = cartRemoveButton.closest('cart-drawer') !== null;
    
    e.preventDefault();
    e.stopPropagation();
    
    const index = cartRemoveButton.dataset.index;
    
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        line: index,
        quantity: 0
      })
    })
    .then(response => response.json())
    .then(data => {
      if (isInDrawer) {
        updateDrawer();
      } else {
        updateCartPage();
      }
    })
    .catch(() => {});
  });
  
  // Handle quantity changes in cart page
  document.addEventListener('change', function(e) {
    const target = e.target;
    
    // Check if this is a quantity input in the main cart page (not drawer)
    if (target.classList.contains('quantity__input') && 
        target.closest('cart-items') && 
        !target.closest('cart-drawer')) {
      
      setTimeout(() => {
        updateCartPage();
      }, 800);
    }
  });
  
  function updateDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    
    if (!cartDrawer) return;
    
    // Update cart icon
    fetch('/cart?section_id=cart-icon-bubble')
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCartIcon = doc.querySelector('.shopify-section');
        const currentCartIcon = document.getElementById('cart-icon-bubble');
        
        if (newCartIcon && currentCartIcon) {
          currentCartIcon.innerHTML = newCartIcon.innerHTML;
        }
      });
    
    // Update drawer content
    fetch('/cart?section_id=cart-drawer')
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCartDrawer = doc.querySelector('cart-drawer');
        
        if (!newCartDrawer) return;
        
        // Update drawer content
        const cartDrawerInner = cartDrawer.querySelector('.cart-drawer');
        const newCartDrawerInner = newCartDrawer.querySelector('.cart-drawer');
        
        if (cartDrawerInner && newCartDrawerInner) {
          cartDrawerInner.innerHTML = newCartDrawerInner.innerHTML;
        }
        
        // Update is-empty class
        if (newCartDrawer.classList.contains('is-empty')) {
          cartDrawer.classList.add('is-empty');
        } else {
          cartDrawer.classList.remove('is-empty');
        }
      });
  }
  
  function updateCartPage() {
    const cartItems = document.querySelector('cart-items');
    
    if (!cartItems) return;
    
    // Get the section ID from the cart items element
    const mainCartItems = document.getElementById('main-cart-items');
    const mainCartFooter = document.getElementById('main-cart-footer');
    
    if (!mainCartItems) return;
    
    const sectionId = mainCartItems.dataset.id;
    
    // Update cart icon
    fetch('/cart?section_id=cart-icon-bubble')
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCartIcon = doc.querySelector('.shopify-section');
        const currentCartIcon = document.getElementById('cart-icon-bubble');
        
        if (newCartIcon && currentCartIcon) {
          currentCartIcon.innerHTML = newCartIcon.innerHTML;
        }
      });
    
    // Update cart items section
    if (sectionId) {
      fetch(`/cart?section_id=${sectionId}`)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          // Update cart items content
          const newContent = doc.querySelector('.js-contents');
          const currentContent = mainCartItems.querySelector('.js-contents');
          
          if (newContent && currentContent) {
            currentContent.innerHTML = newContent.innerHTML;
          }
          
          // Update is-empty class
          const newCartItems = doc.querySelector('cart-items');
          if (newCartItems && newCartItems.classList.contains('is-empty')) {
            cartItems.classList.add('is-empty');
          } else {
            cartItems.classList.remove('is-empty');
          }
        });
    }
    
    // Update cart footer (totals, checkout button)
    if (mainCartFooter) {
      const footerSectionId = mainCartFooter.dataset.id;
      if (footerSectionId) {
        fetch(`/cart?section_id=${footerSectionId}`)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            
            const newFooterContent = doc.querySelector('.js-contents');
            const currentFooterContent = mainCartFooter.querySelector('.js-contents');
            
            if (newFooterContent && currentFooterContent) {
              currentFooterContent.innerHTML = newFooterContent.innerHTML;
            }
            
            // Update is-empty class on footer
            if (cartItems.classList.contains('is-empty')) {
              mainCartFooter.classList.add('is-empty');
            } else {
              mainCartFooter.classList.remove('is-empty');
            }
          });
      }
    }
  }
})();

